import { Component, OnInit } from "@angular/core";
import { ControlContainer, FormGroup } from "@angular/forms";
import { PessoaJuridicaDTO } from "app/model/dtos/grl/pessoa-juridica.dto";
import { ParentFormGroup } from "app/tools/parent-formgroup";
import { DialogFactory } from "sol-tools-ts/dist";

@Component({
  selector: "concessionario-pessoa-juridica",
  templateUrl: "./concessionario-pessoa-juridica.component.html",
  styleUrls: ["./concessionario-pessoa-juridica.component.scss"],
  viewProviders: [ParentFormGroup]
})
export class ConcessionarioPessoaJuridicaComponent implements OnInit {

  formGroup: FormGroup;
  
  constructor(
    private _controlContainer: ControlContainer,
    private _dialogFactory: DialogFactory
  ) {}

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
  }

  async onCNPJResponse(pessoaJuridicaDTO: PessoaJuridicaDTO) {
    if (pessoaJuridicaDTO == undefined || pessoaJuridicaDTO.cdPessoa == undefined) {
      this.formGroup.get('pessoa').reset();
      this.formGroup.get('pessoa').get('pessoaEndereco').reset();
      return; 
    }

    
    this.formGroup.get('pessoa').patchValue(pessoaJuridicaDTO.pessoaDTO);
    this.formGroup.get('pessoa').get('pessoaEndereco').patchValue(pessoaJuridicaDTO.pessoaDTO.pessoaEndereco);
    this.formGroup.patchValue(pessoaJuridicaDTO);
  }
}
